import store from '@/store'

export default [
  {
    path: '/thesis',
    name: 'thesis',
    meta: { requiresAuth: true },
    component: () => import('@/pages/thesis/index.vue')
  },
  {
    path: '/thesis/create',
    name: 'thesis-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/thesis/create.vue')
  },
  {
    path: '/thesis/:id',
    name: 'thesis-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/thesis/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('thesis/find', to.params.id)
      next()
    }
  }
]
